import {
  GET_TOURS,
  TOUR_ERROR,
  UPDATE_TOUR_LIKES,
  DELETE_TOUR,
  ADD_TOUR,
  GET_TOUR,
  CLEAR_TOURS,
} from "../actions/types";

const initialState = {
  tours: [],
  tour: null,
  tourloading: false,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TOURS:
      return {
        ...state,
        tours: payload,
        tourloading: false,
      };
    case GET_TOUR:
      return {
        ...state,
        tour: payload,
        tourloading: false,
      };
    case ADD_TOUR:
      return {
        ...state,
        tour: payload,
        tourloading: false,
      };
    case DELETE_TOUR:
      return {
        ...state,
        vrtours: state.vrtours.filter((tour) => tour._id !== payload),
        tourloading: false,
      };
    case TOUR_ERROR:
      return {
        ...state,
        error: payload,
        tourloading: false,
      };
    case UPDATE_TOUR_LIKES:
      return {
        ...state,
        vrtours: state.vrtours.map((tour) =>
          tour._id === payload.id ? { ...tour, likes: payload.likes } : tour
        ),
        tourloading: false,
      };
    case CLEAR_TOURS:
      return {
        ...state,
        vrtours: [],
        tour: null,
        tourloading: false,
      };
    default:
      return state;
  }
}
